const state = {
  user: sessionStorage.getItem('control')||0,
};

// getters
const getters = {
  getUser:state=>{
    return state.user
  }
};

// actions
const actions = {
  setUser({ commit },str){
    commit('changeUser',str)
  },
};

// mutations
const mutations = {
  changeUser(state,str){
    state.user=str;
    //sessionStorage.setItem('control',state.user)
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/comm/store/modules/jurisdiction.js